export default class MiniGameImages {
  public main: string;
  public mobile: string;
}
